import { tokens } from '@fluentui/react-components'

// Shared by ContextCard (chat input) and MessageSources (chat bubble) so a file/section entry looks the same in both.
export const CONTEXT_ENTRY_ICON_SIZE = '16px'
export const CONTEXT_ENTRY_ICON_GAP = tokens.spacingHorizontalXXS
// Extra space between the file icon and the file name.
export const CONTEXT_ENTRY_TEXT_INSET = tokens.spacingHorizontalXS

export const contextEntryText = {
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
}

export const contextEntrySection = {
  height: '20px',
  paddingInline: tokens.spacingHorizontalSNudge,
  gap: tokens.spacingHorizontalXXS,
}
